import React, { useMemo } from "react";
import { CommentType } from "../../../../../dtos/CommentType";
import { GrantDto } from "../../../../../dtos/GrantDto";
import { StepDto } from "../../../../../dtos/StepDto";
import TaskFileUploader from "./FileUploader";

type Props = {
    grant: GrantDto;
    step: StepDto;
    xsrfToken: string;
    isDisabled: boolean;
};

// Submission (legacy DC document) steps upload into named slots ("Drawings", "Specs", "BOD",
// "Review", ...) defined by the step's FileRestrictions config. We render one labeled uploader per
// slot so each file routes to its slot (via fileLabel) and is constrained to that slot's extensions;
// the backend renames the stored file to the slot's canonical name, matching how legacy SD drops in
// files. Unrestricted (or unconfigured) steps fall back to the single generic uploader.
export default function SubmissionFileUploaders({ grant, step, xsrfToken, isDisabled }: Props) {
    const settings = step.defaultStep?.settings;

    const slots = useMemo(
        () => (settings?.unrestrictedUpload ? null : settings?.fileRestrictions) ?? null,
        [settings?.unrestrictedUpload, settings?.fileRestrictions]
    );

    // Unrestricted (or unconfigured) steps: a single generic uploader. These are the catch-all
    // folders ("Other Documents"), where a user routinely has several files to add at once.
    if (!slots || slots.length === 0) {
        return (
            <TaskFileUploader
                grant={grant}
                step={step}
                xsrfToken={xsrfToken}
                isDisabled={isDisabled}
                fileType={CommentType.None}
                multiple={true}
            />
        );
    }

    // Restricted slot steps: upload/replace happens in the slot file list (SubTaskFilesView),
    // which opens a dialog hosting this same uploader per slot. Nothing to render here.
    return null;
}
